import React from "react";
import { useFormikContext } from "formik";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";

// see https://stackoverflow.com/a/58650742/193886
export const DatePickerField = ({ value, ...props }) => {
  const { setFieldValue } = useFormikContext();
  // DatePicker werkt intern met een Date object (je mag selected vullen met "2020-01-01")
  // dateFormat="dd-MM-yyyy" bepaalt hoe de user-interface het weergeeft (deze kun je localiseren)
  // onChange levert een Date op, formateer deze weer zoals wij intern werken (met "YYYY-MM-DD")
  return (
    <DatePicker
      {...props}
      dateFormat="dd-MM-yyyy"
      selected={(value && new Date(value)) || null}
      onChange={(val) => {
        setFieldValue(props.name, val && moment(val).format("YYYY-MM-DD"));
      }}
    />
  );
};
